import {Component, OnInit} from '@angular/core';
import {ChangelogService} from '../../../services/gui/changelog/changelog.service';

@Component({
  selector: 'sb-page-debug-version',
  templateUrl: './debug-version.component.html',
  styleUrls: ['./debug-version.component.scss'],
  standalone: false,
})
export class DebugVersionComponent implements OnInit {
  constructor(public changelogService: ChangelogService) {}

  ngOnInit(): void {
    console.log(this.changelogService.frontendVersion);
  }
}
